import React, { useState, useEffect, useRef } from 'react';
import worldMap from '../assets/world_map.png';

const GlobalReach = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [showLocations, setShowLocations] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.1 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    const stats = [
        { label: "Countries Served", value: "25+" },
        { label: "Global Offices", value: "3" },
        { label: "Team Members", value: "150+" },
        { label: "Partner Network", value: "25+" }
    ];

    return (
        <section ref={sectionRef} className="relative py-24 bg-slate-900 overflow-hidden">
            {/* Background Map Image */}
            <div className="absolute inset-0 z-0 opacity-20">
                <img
                    src={worldMap}
                    alt="Global Network Map"
                    className="w-full h-full object-cover"
                />
            </div>

            {/* Radial Gradient Overlay for better text readability */}
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-transparent to-slate-900 z-0"></div>

            <div className="container-custom relative z-10">
                <div className={`text-center mb-16 ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`}>
                    <h2 className="font-display text-4xl lg:text-5xl font-bold text-white mb-6">
                        Global Reach, Local Impact
                    </h2>
                    <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-cyan-400 mx-auto mb-8"></div>
                    <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
                        Connecting businesses with technology excellence across borders. Our distributed team and global network ensure we deliver world-class solutions wherever you are.
                    </p>
                </div>

                <div className={`grid grid-cols-2 md:grid-cols-4 gap-8 ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`} style={{ animationDelay: '0.3s' }}>
                    {stats.map((stat, index) => (
                        <div key={index} className="text-center p-6 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 hover:bg-white/10 transition-colors">
                            <div className="text-4xl lg:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-300 mb-2 font-display">
                                {stat.value}
                            </div>
                            <div className="text-gray-400 font-medium uppercase tracking-wider text-sm">
                                {stat.label}
                            </div>
                        </div>
                    ))}
                </div>

                <div className={`mt-16 text-center ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`} style={{ animationDelay: '0.6s' }}>
                    <button
                        onClick={() => setShowLocations(!showLocations)}
                        className="bg-transparent border-2 border-white/30 text-white px-8 py-3 rounded-xl font-semibold backdrop-blur-sm transition-all duration-300 transform hover:scale-105 hover:bg-white/10 focus:outline-none"
                    >
                        {showLocations ? 'Hide Locations' : 'View Our Locations'}
                    </button>
                </div>

                {/* Locations Grid */}
                <div className={`transition-all duration-500 overflow-hidden ${showLocations ? 'max-h-[500px] opacity-100 mt-12' : 'max-h-0 opacity-0 mt-0'}`}>
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl mx-auto pb-4">
                        {['Dubai', 'Calicut', 'Toronto'].map((city, idx) => (
                            <div key={idx} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 text-center hover:bg-white/10 transition-colors group">
                                <svg className="w-8 h-8 mx-auto text-blue-400 mb-4 group-hover:scale-110 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                <h3 className="text-xl font-bold text-white tracking-wide">{city}</h3>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default GlobalReach;
